const firebaseConfig = {
    apiKey: "AIzaSyCaNa07v6gb5vUAeEEodOMj7IonpMpacFE",
    authDomain: "fresh-garden-project.firebaseapp.com",
    projectId: "fresh-garden-project",
    storageBucket: "fresh-garden-project.appspot.com",
    messagingSenderId: "1021133194846",
    appId: "1:1021133194846:web:1ecfebd6aaa2b7f92b56cf"
  };
  export default firebaseConfig;